// initial state
const state = () => ({
  currentComponent: null,
})

// getters
const getters = {
  getCurrentComponent: state => {
    return state.currentComponent;
  },
}

// actions
const actions = {}

// mutations
const mutations = {
  setCurrentComponent: (state, currentComponent) => {
    state.currentComponent = currentComponent;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
